import { LogoutBloqueadoError, useAuthStore } from "@/stores/AuthStore";
import { useToast } from "primevue/usetoast";
import { useRouter } from "vue-router";

/**
 * Ponto único de saída do sistema, usado por todo botão "Sair" do app
 * (Sidebarmenu.vue, TopBarDashboardChip.vue). Existe para não repetir o
 * tratamento do 409 que AuthStore.logout() lança quando há uma sessão de
 * "acessar como outro usuário" ativa — nesse caso a sessão NÃO pode ser
 * derrubada (apagaria as credenciais da pessoa acessada em todos os
 * dispositivos dela), então só avisamos quem clicou, sem navegar.
 *
 * Um segundo botão de logout no projeto chamava o serviço direto, sem
 * `catch`: a rejeição do 409 virava erro não tratado, silencioso — nem
 * aviso, nem navegação. Centralizar aqui evita que um terceiro botão repita
 * o erro.
 */
export function useLogout() {
  const authStore = useAuthStore();
  const router = useRouter();
  const toast = useToast();

  async function sair(): Promise<void> {
    try {
      await authStore.logout();
      await router.push({ name: "login" });
    } catch (error) {
      if (error instanceof LogoutBloqueadoError) {
        toast.add({
          severity: "warn",
          summary: "Não foi possível sair",
          detail: error.message,
          life: 6000,
        });
        return;
      }

      console.error("Erro ao sair do sistema:", error);
      toast.add({
        severity: "error",
        summary: "Erro",
        detail: "Não foi possível sair do sistema. Tente novamente.",
        life: 3000,
      });
    }
  }

  return { sair };
}
